export default __webpack_public_path__ + "static/media/team2.b4819166.png";